import {
  CRM_APP,
  PLATFORM_APP,
  SETUP_APP
} from "./permissionsMenus";

// ============================================================================
// 3. PLATFORM APP
// ============================================================================
const { PLATFORM, CRM_MODULE: PLATFORM_CRM_MODULE } = PLATFORM_APP;

const {
  CRM: PLATFORM_CRM,
  FEATURES: PLATFORM_CRM_FEATURES,
} = PLATFORM_CRM_MODULE;
const {
  COMPETITOR_ROLE,
  COMPETITOR_THREAT_LEVEL,
  CONSENT_STATUS,
  CRM_STATUS,
  CUSTOMER_CATEGORY,
  CUSTOMER_STATUS,
  CUSTOMER_TYPE,
  INQUIRY_DISPOSITION,
  LEAD_QUALIFICATION_STATUS,
  OPPORTUNITY_STAGE,
  PERSON_TITLE,
} = PLATFORM_CRM_FEATURES;

const PLATFORM_PERMISSIONS = {
  CRM: {
    COMPETITOR_ROLE: {
      get: "Platform.CRM.CompetitorRole.get",
      create: "Platform.CRM.CompetitorRole.create",
      update: "Platform.CRM.CompetitorRole.update",
      delete: "Platform.CRM.CompetitorRole.delete",
    },
    COMPETITOR_THREAT_LEVEL: {
      get: "Platform.CRM.CompetitorThreatLevel.get",
      create: "Platform.CRM.CompetitorThreatLevel.create",
      update: "Platform.CRM.CompetitorThreatLevel.update",
      delete: "Platform.CRM.CompetitorThreatLevel.delete",
    },
    CONSENT_STATUS: {
      read: "Platform.CRM.ConsentStatus.read",
      create: "Platform.CRM.ConsentStatus.create",
      update: "Platform.CRM.ConsentStatus.update",
      delete: "Platform.CRM.ConsentStatus.delete",
    },
    CRM_STATUS: {
      read: "Platform.CRM.CRMStatus.read",
      create: "Platform.CRM.CRMStatus.create",
      update: "Platform.CRM.CRMStatus.update",
      delete: "Platform.CRM.CRMStatus.delete",
    },
    CUSTOMER_CATEGORY: {
      read: "Platform.CRM.CustomerCategory.read",
      create: "Platform.CRM.CustomerCategory.create",
      update: "Platform.CRM.CustomerCategory.update",
      delete: "Platform.CRM.CustomerCategory.delete",
    },
    CUSTOMER_STATUS: {
      read: "Platform.CRM.CustomerStatus.read",
      create: "Platform.CRM.CustomerStatus.create",
      update: "Platform.CRM.CustomerStatus.update",
      delete: "Platform.CRM.CustomerStatus.delete",
    },
    CUSTOMER_TYPE: {
      read: "Platform.CRM.CustomerType.read",
      create: "Platform.CRM.CustomerType.create",
      update: "Platform.CRM.CustomerType.update",
      delete: "Platform.CRM.CustomerType.delete",
    },
    INQUIRY_DISPOSITION: {
      read: "Platform.CRM.InquiryDisposition.read",
      create: "Platform.CRM.InquiryDisposition.create",
      update: "Platform.CRM.InquiryDisposition.update",
      delete: "Platform.CRM.InquiryDisposition.delete",
    },
    LEAD_QUALIFICATION_STATUS: {
      read: "Platform.CRM.LeadQualificationStatus.read",
      create: "Platform.CRM.LeadQualificationStatus.create",
      update: "Platform.CRM.LeadQualificationStatus.update",
      delete: "Platform.CRM.LeadQualificationStatus.delete",
    },
    OPPORTUNITY_STAGE: {
      read: "Platform.CRM.OpportunityStage.read",
      create: "Platform.CRM.OpportunityStage.create",
      update: "Platform.CRM.OpportunityStage.update",
      delete: "Platform.CRM.OpportunityStage.delete",
    },
    PERSON_TITLE: {
      get: "Platform.CRM.PersonTitle.get",
      create: "Platform.CRM.PersonTitle.create",
      update: "Platform.CRM.PersonTitle.update",
      delete: "Platform.CRM.PersonTitle.delete",
    },
  },
};

// ============================================================================
// 4. CRM APP
// ============================================================================
const {
  CRM,
  CONFIG_MODULE,
  GENERATE_MODULE,
  ORCHESTRATE_MODULE,
  RELATE_MODULE,
} = CRM_APP;

const { CONFIG, FEATURES: CONFIG_FEATURES } = CONFIG_MODULE;
const {
  COMPETITOR,
  COMPETITOR_ANALYSIS,
  IDEAL_CUSTOMER_PROFILE,
  MARKET,
  PRIVACY_CONSENT,
  PRODUCT_CONFIG,
  PRODUCTS,
  SALES_REGION,
  SALES_TERRITORY,
  SERVICES,
} = CONFIG_FEATURES;

const { GENERATE, FEATURES: GENERATE_FEATURES } = GENERATE_MODULE;
const {
  CAMPAIGN_MANAGEMENT,
  INQUIRY_MANAGEMENT,
  LEAD_MANAGEMENT,
  PROSPECT_MANAGEMENT,
  STATUS_HISTORY,
} = GENERATE_FEATURES;

const { ORCHESTRATE, FEATURES: ORCHESTRATE_FEATURES } = ORCHESTRATE_MODULE;
const { OPPORTUNITY_MANAGEMENT, WON_CONTRACT, WON_ORDER } = ORCHESTRATE_FEATURES;

const { RELATE, FEATURES: RELATE_FEATURES } = RELATE_MODULE;
const {
  CONTACT,
  CUSTOMER_ACCOUNT,
  CUSTOMERS,
} = RELATE_FEATURES;

const CRM_PERMISSIONS = {
  CONFIG: {
    COMPETITOR: {
      read: "CRM.Config.Competitor.read",
      create: "CRM.Config.Competitor.create",
      update: "CRM.Config.Competitor.update",
      delete: "CRM.Config.Competitor.delete",
    },
    COMPETITOR_ANALYSIS: {
      read: "CRM.Config.CompetitorAnalysis.read",
      create: "CRM.Config.CompetitorAnalysis.create",
      update: "CRM.Config.CompetitorAnalysis.update",
      delete: "CRM.Config.CompetitorAnalysis.delete",
    },
    IDEAL_CUSTOMER_PROFILE: {
      read: "CRM.Config.IdealCustomerProfile.read",
      create: "CRM.Config.IdealCustomerProfile.create",
      update: "CRM.Config.IdealCustomerProfile.update",
      delete: "CRM.Config.IdealCustomerProfile.delete",
    },
    MARKET: {
      readSubSegment: "CRM.Config.Market.readSubSegment",
      createSubSegment: "CRM.Config.Market.createSubSegment",
      updateSubSegment: "CRM.Config.Market.updateSubSegment",
      deleteSubSegment: "CRM.Config.Market.deleteSubSegment",
      readMarketSegment: "CRM.Config.Market.readMarketSegment",
      readMarketSegmentById: "CRM.Config.Market.readMarketSegmentById",
      createMarketSegment: "CRM.Config.Market.createMarketSegment",
      updateMarketSegment: "CRM.Config.Market.updateMarketSegment",
      deleteMarketSegment: "CRM.Config.Market.deleteMarketSegment",
      read: "CRM.Config.Market.read",
      create: "CRM.Config.Market.create",
      update: "CRM.Config.Market.update",
      delete: "CRM.Config.Market.delete",
    },
    PRIVACY_CONSENT: {
      read: "CRM.Config.PrivacyConsent.read",
      create: "CRM.Config.PrivacyConsent.create",
      update: "CRM.Config.PrivacyConsent.update",
      delete: "CRM.Config.PrivacyConsent.delete",
    },
    PRODUCT_CONFIG: {
      readProductType: "CRM.Config.ProductConfig.readProductType",
      createProductType: "CRM.Config.ProductConfig.createProductType",
      updateProductType: "CRM.Config.ProductConfig.updateProductType",
      deleteProductType: "CRM.Config.ProductConfig.deleteProductType",
      readProductCategory: "CRM.Config.ProductConfig.readProductCategory",
      createProductCategory: "CRM.Config.ProductConfig.createProductCategory",
      updateProductCategory: "CRM.Config.ProductConfig.updateProductCategory",
      deleteProductCategory: "CRM.Config.ProductConfig.deleteProductCategory",
    },
    PRODUCTS: {
      readProductVariant: "CRM.Config.Products.readProductVariant",
      readProductVariantByProductId: "CRM.Config.Products.readProductVariantByProductId",
      readProductVariantDetailById: "CRM.Config.Products.readProductVariantDetailById",
      createProductVariant: "CRM.Config.Products.createProductVariant",
      updateProductVariant: "CRM.Config.Products.updateProductVariant",
      deleteProductVariant: "CRM.Config.Products.deleteProductVariant",
      readProductModule: "CRM.Config.Products.readProductModule",
      readProductModuleById: "CRM.Config.Products.readProductModuleById",
      createProductModule: "CRM.Config.Products.createProductModule",
      updateProductModule: "CRM.Config.Products.updateProductModule",
      deleteProductModule: "CRM.Config.Products.deleteProductModule",
      readProductFeature: "CRM.Config.Products.readProductFeature",
      readProductFeatureById: "CRM.Config.Products.readProductFeatureById",
      createProductFeature: "CRM.Config.Products.createProductFeature",
      updateProductFeature: "CRM.Config.Products.updateProductFeature",
      deleteProductFeature: "CRM.Config.Products.deleteProductFeature",
      read: "CRM.Config.Products.read",
      create: "CRM.Config.Products.create",
      update: "CRM.Config.Products.update",
      delete: "CRM.Config.Products.delete",
    },
    SALES_REGION: {
      read: "CRM.Config.SalesRegion.read",
      create: "CRM.Config.SalesRegion.create",
      update: "CRM.Config.SalesRegion.update",
      delete: "CRM.Config.SalesRegion.delete",
    },
    SALES_TERRITORY: {
      read: "CRM.Config.SalesTerritory.read",
      readSalesTerritoryById: "CRM.Config.SalesTerritory.readSalesTerritoryById",
      create: "CRM.Config.SalesTerritory.create",
      update: "CRM.Config.SalesTerritory.update",
      delete: "CRM.Config.SalesTerritory.delete",
    },
    SERVICES: {
      read: "CRM.Config.Services.read",
      create: "CRM.Config.Services.create",
      update: "CRM.Config.Services.update",
      delete: "CRM.Config.Services.delete",
    },
  },
  GENERATE: {
    CAMPAIGN_MANAGEMENT: {
      readTargetSegment: "CRM.Generate.CampaignManagement.readTargetSegment",
      readTargetSegmentById: "CRM.Generate.CampaignManagement.readTargetSegmentById",
      createTargetSegment: "CRM.Generate.CampaignManagement.createTargetSegment",
      updateTargetSegment: "CRM.Generate.CampaignManagement.updateTargetSegment",
      deleteTargetSegment: "CRM.Generate.CampaignManagement.deleteTargetSegment",
      read: "CRM.Generate.CampaignManagement.read",
      create: "CRM.Generate.CampaignManagement.create",
      update: "CRM.Generate.CampaignManagement.update",
      delete: "CRM.Generate.CampaignManagement.delete",
      readCampaignTeam: "CRM.Generate.CampaignManagement.readCampaignTeam",
      createCampaignTeam: "CRM.Generate.CampaignManagement.createCampaignTeam",
      updateCampaignTeam: "CRM.Generate.CampaignManagement.updateCampaignTeam",
      deleteCampaignTeam: "CRM.Generate.CampaignManagement.deleteCampaignTeam",
      readCrmTeam: "CRM.Generate.CampaignManagement.readCrmTeam",
      readCrmTeamById: "CRM.Generate.CampaignManagement.readCrmTeamById",
      createCrmTeam: "CRM.Generate.CampaignManagement.createCrmTeam",
      updateCrmTeam: "CRM.Generate.CampaignManagement.updateCrmTeam",
      deleteCrmTeam: "CRM.Generate.CampaignManagement.deleteCrmTeam",
      readCampaignTargetMetric: "CRM.Generate.CampaignManagement.readCampaignTargetMetric",
      readCampaignTargetMetricByCampaignId: "CRM.Generate.CampaignManagement.readCampaignTargetMetricByCampaignId",
      createCampaignTargetMetric: "CRM.Generate.CampaignManagement.createCampaignTargetMetric",
      readCampaignChannel: "CRM.Generate.CampaignManagement.readCampaignChannel",
      createCampaignChannel: "CRM.Generate.CampaignManagement.createCampaignChannel",
      updateCampaignChannel: "CRM.Generate.CampaignManagement.updateCampaignChannel",
      deleteCampaignChannel: "CRM.Generate.CampaignManagement.deleteCampaignChannel",
      readCampaign: "CRM.Generate.CampaignManagement.readCampaign",
      readCampaignByOwner: "CRM.Generate.CampaignManagement.readCampaignByOwner",
      readCampaignById: "CRM.Generate.CampaignManagement.readCampaignById",
      deleteAlertCampaign: "CRM.Generate.CampaignManagement.deleteAlertCampaign",
      createCampaign: "CRM.Generate.CampaignManagement.createCampaign",
      updateCampaign: "CRM.Generate.CampaignManagement.updateCampaign",
      deleteCampaign: "CRM.Generate.CampaignManagement.deleteCampaign",
      readStatusHistoryById: "CRM.Generate.CampaignManagement.readStatusHistoryById",
      readAttachment: "CRM.Generate.CampaignManagement.readAttachment",
      readAttachmentById: "CRM.Generate.CampaignManagement.readAttachmentById",
      viewAttachment: "CRM.Generate.CampaignManagement.viewAttachment",
      createAttachment: "CRM.Generate.CampaignManagement.createAttachment",
      updateAttachment: "CRM.Generate.CampaignManagement.updateAttachment",
      deleteAttachment: "CRM.Generate.CampaignManagement.deleteAttachment",
      readActivity: "CRM.Generate.CampaignManagement.readActivity",
      readActivityByDetails: "CRM.Generate.CampaignManagement.readActivityByDetails",
      readActivityById: "CRM.Generate.CampaignManagement.readActivityById",
      createActivity: "CRM.Generate.CampaignManagement.createActivity",
      updateActivity: "CRM.Generate.CampaignManagement.updateActivity",
      deleteActivity: "CRM.Generate.CampaignManagement.deleteActivity",
    },
    INQUIRY_MANAGEMENT: {
      createInquiryTagging: "CRM.Generate.InquiryManagement.createInquiryTagging",
      readInquiryTagging: "CRM.Generate.InquiryManagement.readInquiryTagging",
      readInquirySource: "CRM.Generate.InquiryManagement.readInquirySource",
      readInquirySourceById: "CRM.Generate.InquiryManagement.readInquirySourceById",
      createInquirySource: "CRM.Generate.InquiryManagement.createInquirySource",
      readInquiryQualification: "CRM.Generate.InquiryManagement.readInquiryQualification",
      readInquiryQualificationById: "CRM.Generate.InquiryManagement.readInquiryQualificationById",
      createInquiryQualification: "CRM.Generate.InquiryManagement.createInquiryQualification",
      readInquiryConversion: "CRM.Generate.InquiryManagement.readInquiryConversion",
      createInquiryConversion: "CRM.Generate.InquiryManagement.createInquiryConversion",
      convertInquiryToLead: "CRM.Generate.InquiryManagement.convertInquiryToLead",
      convertInquiryToProspect: "CRM.Generate.InquiryManagement.convertInquiryToProspect",
      updateInquiryConversion: "CRM.Generate.InquiryManagement.updateInquiryConversion",
      deleteInquiryConversion: "CRM.Generate.InquiryManagement.deleteInquiryConversion",
      readInquiry: "CRM.Generate.InquiryManagement.readInquiry",
      readInquiryByOwner: "CRM.Generate.InquiryManagement.readInquiryByOwner",
      createInquiry: "CRM.Generate.InquiryManagement.createInquiry",
      readInquiryById: "CRM.Generate.InquiryManagement.readInquiryById",
      deleteAlertInquiry: "CRM.Generate.InquiryManagement.deleteAlertInquiry",
      updateInquiry: "CRM.Generate.InquiryManagement.updateInquiry",
      deleteInquiry: "CRM.Generate.InquiryManagement.deleteInquiry",
      readCrmTeam: "CRM.Generate.InquiryManagement.readCrmTeam",
      readCrmTeamById: "CRM.Generate.InquiryManagement.readCrmTeamById",
      createCrmTeam: "CRM.Generate.InquiryManagement.createCrmTeam",
      updateCrmTeam: "CRM.Generate.InquiryManagement.updateCrmTeam",
      deleteCrmTeam: "CRM.Generate.InquiryManagement.deleteCrmTeam",
      readActivity: "CRM.Generate.InquiryManagement.readActivity",
      readActivityById: "CRM.Generate.InquiryManagement.readActivityById",
      createActivity: "CRM.Generate.InquiryManagement.createActivity",
      updateActivity: "CRM.Generate.InquiryManagement.updateActivity",
      deleteActivity: "CRM.Generate.InquiryManagement.deleteActivity",
    },
    LEAD_MANAGEMENT: {
      readLeadTagging: "CRM.Generate.LeadManagement.readLeadTagging",
      createLeadTagging: "CRM.Generate.LeadManagement.createLeadTagging",
      readLeadSource: "CRM.Generate.LeadManagement.readLeadSource",
      createLeadSource: "CRM.Generate.LeadManagement.createLeadSource",
      readLeadQualification: "CRM.Generate.LeadManagement.readLeadQualification",
      createLeadQualification: "CRM.Generate.LeadManagement.createLeadQualification",
      readLeadProspectMapping: "CRM.Generate.LeadManagement.readLeadProspectMapping",
      createLeadProspectMapping: "CRM.Generate.LeadManagement.createLeadProspectMapping",
      updateLeadProspectMapping: "CRM.Generate.LeadManagement.updateLeadProspectMapping",
      deleteLeadProspectMapping: "CRM.Generate.LeadManagement.deleteLeadProspectMapping",
      convertToOpportunity: "CRM.Generate.LeadManagement.convertToOpportunity",
      convertToAccount: "CRM.Generate.LeadManagement.convertToAccount",
      convertToContact: "CRM.Generate.LeadManagement.convertToContact",
      readLead: "CRM.Generate.LeadManagement.readLead",
      readLeadByOwner: "CRM.Generate.LeadManagement.readLeadByOwner",
      readLeadById: "CRM.Generate.LeadManagement.readLeadById",
      createLead: "CRM.Generate.LeadManagement.createLead",
      deleteAlertLead: "CRM.Generate.LeadManagement.deleteAlertLead",
      updateLead: "CRM.Generate.LeadManagement.updateLead",
      deleteLead: "CRM.Generate.LeadManagement.deleteLead",
      readCrmTeam: "CRM.Generate.LeadManagement.readCrmTeam",
      readCrmTeamById: "CRM.Generate.LeadManagement.readCrmTeamById",
      createCrmTeam: "CRM.Generate.LeadManagement.createCrmTeam",
      updateCrmTeam: "CRM.Generate.LeadManagement.updateCrmTeam",
      deleteCrmTeam: "CRM.Generate.LeadManagement.deleteCrmTeam",
      readActivity: "CRM.Generate.LeadManagement.readActivity",
      readActivityById: "CRM.Generate.LeadManagement.readActivityById",
      createActivity: "CRM.Generate.LeadManagement.createActivity",
      updateActivity: "CRM.Generate.LeadManagement.updateActivity",
      deleteActivity: "CRM.Generate.LeadManagement.deleteActivity",
    },
    PROSPECT_MANAGEMENT: {
      readProspectTagging: "CRM.Generate.ProspectManagement.readProspectTagging",
      readProspectTaggingById: "CRM.Generate.ProspectManagement.readProspectTaggingById",
      readProspectTaggingByProspectId: "CRM.Generate.ProspectManagement.readProspectTaggingByProspectId",
      createProspectTagging: "CRM.Generate.ProspectManagement.createProspectTagging",
      updateProspectTagging: "CRM.Generate.ProspectManagement.updateProspectTagging",
      deleteProspectTagging: "CRM.Generate.ProspectManagement.deleteProspectTagging",
      readProspectSource: "CRM.Generate.ProspectManagement.readProspectSource",
      readProspectSourceByProspectId: "CRM.Generate.ProspectManagement.readProspectSourceByProspectId",
      createProspectSource: "CRM.Generate.ProspectManagement.createProspectSource",
      readProspectQualification: "CRM.Generate.ProspectManagement.readProspectQualification",
      createProspectQualification: "CRM.Generate.ProspectManagement.createProspectQualification",
      readProspectQualificationById: "CRM.Generate.ProspectManagement.readProspectQualificationById",
      readProspectInterest: "CRM.Generate.ProspectManagement.readProspectInterest",
      readProspectInterestByProspectId: "CRM.Generate.ProspectManagement.readProspectInterestByProspectId",
      createProspectInterest: "CRM.Generate.ProspectManagement.createProspectInterest",
      readProspectConversion: "CRM.Generate.ProspectManagement.readProspectConversion",
      createProspectConversion: "CRM.Generate.ProspectManagement.createProspectConversion",
      convertProspectToInquiry: "CRM.Generate.ProspectManagement.convertProspectToInquiry",
      convertProspectToLead: "CRM.Generate.ProspectManagement.convertProspectToLead",
      updateProspectConversion: "CRM.Generate.ProspectManagement.updateProspectConversion",
      deleteProspectConversion: "CRM.Generate.ProspectManagement.deleteProspectConversion",
      readProspectContactEngagement: "CRM.Generate.ProspectManagement.readProspectContactEngagement",
      readProspectContactEngagementByProspectContactId: "CRM.Generate.ProspectManagement.readProspectContactEngagementByProspectContactId",
      createProspectContactEngagement: "CRM.Generate.ProspectManagement.createProspectContactEngagement",
      readProspectContactCommunication: "CRM.Generate.ProspectManagement.readProspectContactCommunication",
      createProspectContactCommunication: "CRM.Generate.ProspectManagement.createProspectContactCommunication",
      readProspectContactCommunicationByProspectContactId: "CRM.Generate.ProspectManagement.readProspectContactCommunicationByProspectContactId",
      readProspectContact: "CRM.Generate.ProspectManagement.readProspectContact",
      readProspectContactById: "CRM.Generate.ProspectManagement.readProspectContactById",
      readDuplicateProspectContact: "CRM.Generate.ProspectManagement.readDuplicateProspectContact",
      readOrganizationProspectContact: "CRM.Generate.ProspectManagement.readOrganizationProspectContact",
      readProspectContactByProspectId: "CRM.Generate.ProspectManagement.readProspectContactByProspectId",
      createProspectContact: "CRM.Generate.ProspectManagement.createProspectContact",
      updateProspectContact: "CRM.Generate.ProspectManagement.updateProspectContact",
      deleteProspectContact: "CRM.Generate.ProspectManagement.deleteProspectContact",
      readProspect: "CRM.Generate.ProspectManagement.readProspect",
      readProspectByOwner: "CRM.Generate.ProspectManagement.readProspectByOwner",
      readProspectById: "CRM.Generate.ProspectManagement.readProspectById",
      deleteAlertProspect: "CRM.Generate.ProspectManagement.deleteAlertProspect",
      createProspect: "CRM.Generate.ProspectManagement.createProspect",
      updateProspect: "CRM.Generate.ProspectManagement.updateProspect",
      deleteProspect: "CRM.Generate.ProspectManagement.deleteProspect",
      uploadProspectsTemplate: "CRM.Generate.ProspectManagement.uploadProspectsTemplate",
      downloadProspects: "CRM.Generate.ProspectManagement.downloadProspects",
      uploadProspects: "CRM.Generate.ProspectManagement.uploadProspects",
      readCrmTeam: "CRM.Generate.ProspectManagement.readCrmTeam",
      readCrmTeamById: "CRM.Generate.ProspectManagement.readCrmTeamById",
      createCrmTeam: "CRM.Generate.ProspectManagement.createCrmTeam",
      updateCrmTeam: "CRM.Generate.ProspectManagement.updateCrmTeam",
      deleteCrmTeam: "CRM.Generate.ProspectManagement.deleteCrmTeam",
      readActivity: "CRM.Generate.ProspectManagement.readActivity",
      readActivityById: "CRM.Generate.ProspectManagement.readActivityById",
      createActivity: "CRM.Generate.ProspectManagement.createActivity",
      updateActivity: "CRM.Generate.ProspectManagement.updateActivity",
      deleteActivity: "CRM.Generate.ProspectManagement.deleteActivity",
    },
    STATUS_HISTORY: {
      createStatusHistory: "CRM.Generate.StatusHistory.createStatusHistory",
      readStatusHistory: "CRM.Generate.StatusHistory.readStatusHistory",
      readStatusHistoryById: "CRM.Generate.StatusHistory.readStatusHistoryById",
      updateStatusHistory: "CRM.Generate.StatusHistory.updateStatusHistory",
      deleteStatusHistory: "CRM.Generate.StatusHistory.deleteStatusHistory",
    },
  },
  ORCHESTRATE: {
    OPPORTUNITY_MANAGEMENT: {
      readOpportunityTagging: "CRM.Orchestrate.OpportunityManagement.readOpportunityTagging",
      readOpportunityTaggingById: "CRM.Orchestrate.OpportunityManagement.readOpportunityTaggingById",
      createOpportunityTagging: "CRM.Orchestrate.OpportunityManagement.createOpportunityTagging",
      createOpportunityStatusHistory: "CRM.Orchestrate.OpportunityManagement.createOpportunityStatusHistory",
      readOpportunityStatusHistory: "CRM.Orchestrate.OpportunityManagement.readOpportunityStatusHistory",
      readOpportunityStatusHistoryById: "CRM.Orchestrate.OpportunityManagement.readOpportunityStatusHistoryById",
      updateOpportunityStatusHistory: "CRM.Orchestrate.OpportunityManagement.updateOpportunityStatusHistory",
      deleteOpportunityStatusHistory: "CRM.Orchestrate.OpportunityManagement.deleteOpportunityStatusHistory",
      readOpportunitySource: "CRM.Orchestrate.OpportunityManagement.readOpportunitySource",
      readOpportunitySourceByOpportunityId: "CRM.Orchestrate.OpportunityManagement.readOpportunitySourceByOpportunityId",
      readOpportunitySourceById: "CRM.Orchestrate.OpportunityManagement.readOpportunitySourceById",
      createOpportunitySource: "CRM.Orchestrate.OpportunityManagement.createOpportunitySource",
      readOpportunityQualification: "CRM.Orchestrate.OpportunityManagement.readOpportunityQualification",
      readOpportunityQualificationById: "CRM.Orchestrate.OpportunityManagement.readOpportunityQualificationById",
      createOpportunityQualification: "CRM.Orchestrate.OpportunityManagement.createOpportunityQualification",
      readOpportunityDetail: "CRM.Orchestrate.OpportunityManagement.readOpportunityDetail",
      readOpportunityDetailById: "CRM.Orchestrate.OpportunityManagement.readOpportunityDetailById",
      createOpportunityDetail: "CRM.Orchestrate.OpportunityManagement.createOpportunityDetail",
      readOpportunityConversion: "CRM.Orchestrate.OpportunityManagement.readOpportunityConversion",
      readOpportunityConversionById: "CRM.Orchestrate.OpportunityManagement.readOpportunityConversionById",
      createOpportunityConversion: "CRM.Orchestrate.OpportunityManagement.createOpportunityConversion",
      updateOpportunityConversion: "CRM.Orchestrate.OpportunityManagement.updateOpportunityConversion",
      deleteOpportunityConversion: "CRM.Orchestrate.OpportunityManagement.deleteOpportunityConversion",
      readOpportunityCompetitorAnalysis: "CRM.Orchestrate.OpportunityManagement.readOpportunityCompetitorAnalysis",
      createOpportunityCompetitorAnalysis: "CRM.Orchestrate.OpportunityManagement.createOpportunityCompetitorAnalysis",
      updateOpportunityCompetitorAnalysis: "CRM.Orchestrate.OpportunityManagement.updateOpportunityCompetitorAnalysis",
      deleteOpportunityCompetitorAnalysis: "CRM.Orchestrate.OpportunityManagement.deleteOpportunityCompetitorAnalysis",
      readOpportunity: "CRM.Orchestrate.OpportunityManagement.readOpportunity",
      readOpportunityByOwner: "CRM.Orchestrate.OpportunityManagement.readOpportunityByOwner",
      createOpportunity: "CRM.Orchestrate.OpportunityManagement.createOpportunity",
      readOpportunityById: "CRM.Orchestrate.OpportunityManagement.readOpportunityById",
      deleteAlertOpportunity: "CRM.Orchestrate.OpportunityManagement.deleteAlertOpportunity",
      updateOpportunity: "CRM.Orchestrate.OpportunityManagement.updateOpportunity",
      deleteOpportunity: "CRM.Orchestrate.OpportunityManagement.deleteOpportunity",
      readCrmTeam: "CRM.Orchestrate.OpportunityManagement.readCrmTeam",
      readCrmTeamById: "CRM.Orchestrate.OpportunityManagement.readCrmTeamById",
      createCrmTeam: "CRM.Orchestrate.OpportunityManagement.createCrmTeam",
      updateCrmTeam: "CRM.Orchestrate.OpportunityManagement.updateCrmTeam",
      deleteCrmTeam: "CRM.Orchestrate.OpportunityManagement.deleteCrmTeam",
      readActivity: "CRM.Orchestrate.OpportunityManagement.readActivity",
      readActivityById: "CRM.Orchestrate.OpportunityManagement.readActivityById",
      createActivity: "CRM.Orchestrate.OpportunityManagement.createActivity",
      updateActivity: "CRM.Orchestrate.OpportunityManagement.updateActivity",
      deleteActivity: "CRM.Orchestrate.OpportunityManagement.deleteActivity",
    },
    WON_CONTRACT: {
      readCrmTeam: "CRM.Won.WonContract.readCrmTeam",
      createCrmTeam: "CRM.Won.WonContract.createCrmTeam",
      updateCrmTeam: "CRM.Won.WonContract.updateCrmTeam",
      deleteCrmTeam: "CRM.Won.WonContract.deleteCrmTeam",
      readContract: "CRM.Won.WonContract.readContract",
      readContractByOwner: "CRM.Won.WonContract.readContractByOwner",
      readContractById: "CRM.Won.WonContract.readContractById",
      createContract: "CRM.Won.WonContract.createContract",
      updateContract: "CRM.Won.WonContract.updateContract",
      deleteContract: "CRM.Won.WonContract.deleteContract",
      readActivity: "CRM.Won.WonContract.readActivity",
      createActivity: "CRM.Won.WonContract.createActivity",
      updateActivity: "CRM.Won.WonContract.updateActivity",
      deleteActivity: "CRM.Won.WonContract.deleteActivity",
    },
    WON_ORDER: {
      readOrder: "CRM.Won.WonOrder.readOrder",
      readOrderByOwner: "CRM.Won.WonOrder.readOrderByOwner",
      readOrderById: "CRM.Won.WonOrder.readOrderById",
      createOrder: "CRM.Won.WonOrder.createOrder",
      updateOrder: "CRM.Won.WonOrder.updateOrder",
      deleteOrder: "CRM.Won.WonOrder.deleteOrder",
      readCrmTeam: "CRM.Won.WonOrder.readCrmTeam",
      createCrmTeam: "CRM.Won.WonOrder.createCrmTeam",
      updateCrmTeam: "CRM.Won.WonOrder.updateCrmTeam",
      deleteCrmTeam: "CRM.Won.WonOrder.deleteCrmTeam",
      readActivity: "CRM.Won.WonOrder.readActivity",
      createActivity: "CRM.Won.WonOrder.createActivity",
      updateActivity: "CRM.Won.WonOrder.updateActivity",
      deleteActivity: "CRM.Won.WonOrder.deleteActivity",
    },
  },
  RELATE: {
    CONTACT: {
      readContactSource: "CRM.Relate.Contact.readContactSource",
      createContactSource: "CRM.Relate.Contact.createContactSource",
      readContactPrivacyConsent: "CRM.Relate.Contact.readContactPrivacyConsent",
      createContactPrivacyConsent: "CRM.Relate.Contact.createContactPrivacyConsent",
      updateContactPrivacyConsent: "CRM.Relate.Contact.updateContactPrivacyConsent",
      deleteContactPrivacyConsent: "CRM.Relate.Contact.deleteContactPrivacyConsent",
      readContactCommunication: "CRM.Relate.Contact.readContactCommunication",
      createContactCommunication: "CRM.Relate.Contact.createContactCommunication",
      readContactByCustomerName: "CRM.Relate.Contact.readContactByCustomerName",
      readContact: "CRM.Relate.Contact.readContact",
      readContactByOwner: "CRM.Relate.Contact.readContactByOwner",
      createContact: "CRM.Relate.Contact.createContact",
      readContactById: "CRM.Relate.Contact.readContactById",
      searchContact: "CRM.Relate.Contact.searchContact",
      updateContact: "CRM.Relate.Contact.updateContact",
      deleteContact: "CRM.Relate.Contact.deleteContact",
      readAddress: "CRM.Relate.Contact.readAddress",
      readAddressByParentId: "CRM.Relate.Contact.readAddressByParentId",
      readAddressById: "CRM.Relate.Contact.readAddressById",
      readAddressDetailById: "CRM.Relate.Contact.readAddressDetailById",
      createAddress: "CRM.Relate.Contact.createAddress",
      updateAddress: "CRM.Relate.Contact.updateAddress",
      deleteAddress: "CRM.Relate.Contact.deleteAddress",
      readCrmTeam: "CRM.Relate.Contact.readCrmTeam",
      readCrmTeamById: "CRM.Relate.Contact.readCrmTeamById",
      createCrmTeam: "CRM.Relate.Contact.createCrmTeam",
      updateCrmTeam: "CRM.Relate.Contact.updateCrmTeam",
      deleteCrmTeam: "CRM.Relate.Contact.deleteCrmTeam",
      readActivity: "CRM.Relate.Contact.readActivity",
      readActivityById: "CRM.Relate.Contact.readActivityById",
      createActivity: "CRM.Relate.Contact.createActivity",
      updateActivity: "CRM.Relate.Contact.updateActivity",
      deleteActivity: "CRM.Relate.Contact.deleteActivity",
    },
    CUSTOMER_ACCOUNT: {
      readCustomerAccountContact: "CRM.Relate.CustomerAccount.readCustomerAccountContact",
      readCustomerAccountContactPublicDomain: "CRM.Relate.CustomerAccount.readCustomerAccountContactPublicDomain",
      createCustomerAccountContact: "CRM.Relate.CustomerAccount.createCustomerAccountContact",
      createCustomerAccountContactTag: "CRM.Relate.CustomerAccount.createCustomerAccountContactTag",
      updateCustomerAccountContact: "CRM.Relate.CustomerAccount.updateCustomerAccountContact",
      readCustomerAccountContactById: "CRM.Relate.CustomerAccount.readCustomerAccountContactById",
      readCustomerAccountContactByCustomerId: "CRM.Relate.CustomerAccount.readCustomerAccountContactByCustomerId",
      readCustomerAccountContactByCustomerAccountId: "CRM.Relate.CustomerAccount.readCustomerAccountContactByCustomerAccountId",
      deleteCustomerAccountContact: "CRM.Relate.CustomerAccount.deleteCustomerAccountContact",
      readCustomerAccount: "CRM.Relate.CustomerAccount.readCustomerAccount",
      readCustomerAccountByOwner: "CRM.Relate.CustomerAccount.readCustomerAccountByOwner",
      readCustomerAccountByCustomerContactId: "CRM.Relate.CustomerAccount.readCustomerAccountByCustomerContactId",
      createCustomerAccount: "CRM.Relate.CustomerAccount.createCustomerAccount",
      readCustomerAccountById: "CRM.Relate.CustomerAccount.readCustomerAccountById",
      searchCustomerAccount: "CRM.Relate.CustomerAccount.searchCustomerAccount",
      updateCustomerAccount: "CRM.Relate.CustomerAccount.updateCustomerAccount",
      deleteCustomerAccount: "CRM.Relate.CustomerAccount.deleteCustomerAccount",
      readAccountBillingDetailById: "CRM.Relate.CustomerAccount.readAccountBillingDetailById",
      readAccountBillingDetail: "CRM.Relate.CustomerAccount.readAccountBillingDetail",
      createAccountBillingDetail: "CRM.Relate.CustomerAccount.createAccountBillingDetail",
      readAccountSourceById: "CRM.Relate.CustomerAccount.readAccountSourceById",
      readAccountSourceByCustomerAccountId: "CRM.Relate.CustomerAccount.readAccountSourceByCustomerAccountId",
      readAccountSource: "CRM.Relate.CustomerAccount.readAccountSource",
      createAccountSource: "CRM.Relate.CustomerAccount.createAccountSource",
      updateAccountSource: "CRM.Relate.CustomerAccount.updateAccountSource",
      deleteAccountSource: "CRM.Relate.CustomerAccount.deleteAccountSource",
      readCrmTeam: "CRM.Relate.CustomerAccount.readCrmTeam",
      readCrmTeamById: "CRM.Relate.CustomerAccount.readCrmTeamById",
      createCrmTeam: "CRM.Relate.CustomerAccount.createCrmTeam",
      updateCrmTeam: "CRM.Relate.CustomerAccount.updateCrmTeam",
      deleteCrmTeam: "CRM.Relate.CustomerAccount.deleteCrmTeam",
      readActivity: "CRM.Relate.CustomerAccount.readActivity",
      readActivityById: "CRM.Relate.CustomerAccount.readActivityById",
      createActivity: "CRM.Relate.CustomerAccount.createActivity",
      updateActivity: "CRM.Relate.CustomerAccount.updateActivity",
      deleteActivity: "CRM.Relate.CustomerAccount.deleteActivity",
    },
    CUSTOMERS: {
      customerType: "CRM.Relate.Customers.customerType",
      customerLocation: "CRM.Relate.Customers.customerLocation",
      customerAccounts: "CRM.Relate.Customers.customerAccounts",
      contactDesignation: "CRM.Relate.Customers.contactDesignation",
      create: "CRM.Relate.Customers.create",
      getById: "CRM.Relate.Customers.getById",
      update: "CRM.Relate.Customers.update",
      delete: "CRM.Relate.Customers.delete",
      search: "CRM.Relate.Customers.search",
      get: "CRM.Relate.Customers.get",
      readCustomerByOwner: "CRM.Relate.Customers.readCustomerByOwner",
      getActiveCustomers: "CRM.Relate.Customers.getActiveCustomers",
      getActiveCustomersForServerSide: "CRM.Relate.Customers.getActiveCustomersForServerSide",
      checkActiveCustomerForServerSide: "CRM.Relate.Customers.checkActiveCustomerForServerSide",
      checkCustomerExistsForServerSide: "CRM.Relate.Customers.checkCustomerExistsForServerSide",
      readCustomerBusinessDetailByCustomerId: "CRM.Relate.Customers.readCustomerBusinessDetailByCustomerId",
      readCustomerBusinessDetailById: "CRM.Relate.Customers.readCustomerBusinessDetailById",
      createCustomerBusinessDetail: "CRM.Relate.Customers.createCustomerBusinessDetail",
      deleteCustomerBusinessDetail: "CRM.Relate.Customers.deleteCustomerBusinessDetail",
      readCrmTeam: "CRM.Relate.Customers.readCrmTeam",
      readCrmTeamById: "CRM.Relate.Customers.readCrmTeamById",
      createCrmTeam: "CRM.Relate.Customers.createCrmTeam",
      updateCrmTeam: "CRM.Relate.Customers.updateCrmTeam",
      deleteCrmTeam: "CRM.Relate.Customers.deleteCrmTeam",
    },
  },
};

// ============================================================================
// 5. SETUP APP
// ============================================================================
const { SETUP, CRM_MODULE: SETUP_CRM_MODULE } = SETUP_APP;
const {
  CRM: SETUP_CRM,
  FEATURES: SETUP_CRM_FEATURES,
} = SETUP_CRM_MODULE;

const {
  ACCOUNT_CATEGORY,
  ACCOUNT_TYPE,
  ACTIVITY,
  ACTIVITY_STATUS,
  ADDRESS_TYPE,
  ASSIGNMENT_TYPE,
  BILLING_FREQUENCY,
  BUDGET_STATUS,
  BUSINESS_NEED_STATUS,
  CAMPAIGN,
  CHANNEL_STATUS,
  CLOSURE_REASON,
  COMPANY_SIZE,
  COMPETITOR_STATUS,
  COMPETITOR_TYPE,
  CONSENT_SOURCE,
  CONTACT_DEPARTMENT,
  CONTACT_METHOD,
  CONTACT_ROLE,
  CONTACT_STATUS,
  CONTACT_TYPE,
  CONTRACT_CATEGORY,
  CONTRACT_STATUS,
  CONTRACT_TYPE,
  CUSTOMER_CURRENCY,
  DECISION_AUTHORITY,
  DISQUALIFICATION_REASON,
  ENGAGEMENT_LEVEL,
  INFLUENCE_LEVEL,
  INQUIRY_TYPE,
  INTENT_LEVEL,
  LEAD_QUALIFICATION_MATURITY,
  LEAD_TYPE,
  NURTURE_REASON,
  OPPORTUNITY_TYPE,
  ORDER_TYPE,
  PAYMENT_TERM,
  PREFERRED_LANGUAGE,
  PRIORITY,
  PROCUREMENT_STATUS,
  PROSPECT_TYPE,
  PURCHASE_TIMELINE,
  QUALIFICATION_READINESS,
  RELATIONSHIP_STATUS,
  RESPONSE_STATUS,
  SEGMENT_TYPE,
  SENIORITY_LEVEL,
  SOURCE,
  TIMELINE_STATUS,
  WIN_LOSS_REASON,
} = SETUP_CRM_FEATURES;

const SETUP_PERMISSIONS = {
  CRM: {
    ACCOUNT_CATEGORY: {
      read: "Setup.CRM.AccountCategory.read",
      create: "Setup.CRM.AccountCategory.create",
      update: "Setup.CRM.AccountCategory.update",
      delete: "Setup.CRM.AccountCategory.delete",
    },
    ACCOUNT_TYPE: {
      read: "Setup.CRM.AccountType.read",
      create: "Setup.CRM.AccountType.create",
      update: "Setup.CRM.AccountType.update",
      delete: "Setup.CRM.AccountType.delete",
    },
    ACTIVITY: {
      readActivityType: "Setup.CRM.Activity.readActivityType",
      createActivityType: "Setup.CRM.Activity.createActivityType",
      updateActivityType: "Setup.CRM.Activity.updateActivityType",
      deleteActivityType: "Setup.CRM.Activity.deleteActivityType",
      readActivityName: "Setup.CRM.Activity.readActivityName",
      readActivityNameById: "Setup.CRM.Activity.readActivityNameById",
      createActivityName: "Setup.CRM.Activity.createActivityName",
      updateActivityName: "Setup.CRM.Activity.updateActivityName",
      deleteActivityName: "Setup.CRM.Activity.deleteActivityName",
    },
    ACTIVITY_STATUS: {
      read: "Setup.CRM.ActivityStatus.read",
      create: "Setup.CRM.ActivityStatus.create",
      update: "Setup.CRM.ActivityStatus.update",
      delete: "Setup.CRM.ActivityStatus.delete",
    },
    ADDRESS_TYPE: {
      get: "Setup.CRM.AddressType.get",
      read: "Setup.CRM.AddressType.get",
      create: "Setup.CRM.AddressType.create",
      update: "Setup.CRM.AddressType.update",
      delete: "Setup.CRM.AddressType.delete",
    },
    ASSIGNMENT_TYPE: {
      read: "Setup.CRM.AssignmentType.read",
      create: "Setup.CRM.AssignmentType.create",
      update: "Setup.CRM.AssignmentType.update",
      delete: "Setup.CRM.AssignmentType.delete",
    },
    BILLING_FREQUENCY: {
      read: "Setup.CRM.BillingFrequency.read",
      create: "Setup.CRM.BillingFrequency.create",
      update: "Setup.CRM.BillingFrequency.update",
      delete: "Setup.CRM.BillingFrequency.delete",
    },
    BUDGET_STATUS: {
      read: "Setup.CRM.BudgetStatus.read",
      create: "Setup.CRM.BudgetStatus.create",
      update: "Setup.CRM.BudgetStatus.update",
      delete: "Setup.CRM.BudgetStatus.delete",
    },
    BUSINESS_NEED_STATUS: {
      read: "Setup.CRM.BusinessNeedStatus.read",
      create: "Setup.CRM.BusinessNeedStatus.create",
      update: "Setup.CRM.BusinessNeedStatus.update",
      delete: "Setup.CRM.BusinessNeedStatus.delete",
    },
    CAMPAIGN: {
      readCampaignType: "Setup.CRM.Campaign.readCampaignType",
      readCampaignTypeById: "Setup.CRM.Campaign.readCampaignTypeById",
      createCampaignType: "Setup.CRM.Campaign.createCampaignType",
      updateCampaignType: "Setup.CRM.Campaign.updateCampaignType",
      deleteCampaignType: "Setup.CRM.Campaign.deleteCampaignType",
      readCampaignCategory: "Setup.CRM.Campaign.readCampaignCategory",
      createCampaignCategory: "Setup.CRM.Campaign.createCampaignCategory",
      updateCampaignCategory: "Setup.CRM.Campaign.updateCampaignCategory",
      deleteCampaignCategory: "Setup.CRM.Campaign.deleteCampaignCategory",
    },
    CHANNEL_STATUS: {
      read: "Setup.CRM.ChannelStatus.read",
      create: "Setup.CRM.ChannelStatus.create",
      update: "Setup.CRM.ChannelStatus.update",
      delete: "Setup.CRM.ChannelStatus.delete",
    },
    CLOSURE_REASON: {
      read: "Setup.CRM.ClosureReason.read",
      create: "Setup.CRM.ClosureReason.create",
      update: "Setup.CRM.ClosureReason.update",
      delete: "Setup.CRM.ClosureReason.delete",
    },
    COMPANY_SIZE: {
      read: "Setup.CRM.CompanySize.read",
      create: "Setup.CRM.CompanySize.create",
      update: "Setup.CRM.CompanySize.update",
      delete: "Setup.CRM.CompanySize.delete",
    },
    COMPETITOR_STATUS: {
      read: "Setup.CRM.CompetitorStatus.read",
      create: "Setup.CRM.CompetitorStatus.create",
      update: "Setup.CRM.CompetitorStatus.update",
      delete: "Setup.CRM.CompetitorStatus.delete",
    },
    COMPETITOR_TYPE: {
      read: "Setup.CRM.CompetitorType.read",
      create: "Setup.CRM.CompetitorType.create",
      update: "Setup.CRM.CompetitorType.update",
      delete: "Setup.CRM.CompetitorType.delete",
    },
    CONSENT_SOURCE: {
      read: "Setup.CRM.ConsentSource.read",
      create: "Setup.CRM.ConsentSource.create",
      update: "Setup.CRM.ConsentSource.update",
      delete: "Setup.CRM.ConsentSource.delete",
    },
    CONTACT_DEPARTMENT: {
      read: "Setup.CRM.ContactDepartment.read",
      create: "Setup.CRM.ContactDepartment.create",
      update: "Setup.CRM.ContactDepartment.update",
      delete: "Setup.CRM.ContactDepartment.delete",
    },
    CONTACT_METHOD: {
      read: "Setup.CRM.ContactMethod.read",
      create: "Setup.CRM.ContactMethod.create",
      update: "Setup.CRM.ContactMethod.update",
      delete: "Setup.CRM.ContactMethod.delete",
    },
    CONTACT_ROLE: {
      read: "Setup.CRM.ContactRole.read",
      readCustomerUser: "Setup.CRM.ContactRole.readCustomerUser",
      create: "Setup.CRM.ContactRole.create",
      update: "Setup.CRM.ContactRole.update",
      delete: "Setup.CRM.ContactRole.delete",
    },
    CONTACT_STATUS: {
      read: "Setup.CRM.ContactStatus.read",
      create: "Setup.CRM.ContactStatus.create",
      update: "Setup.CRM.ContactStatus.update",
      delete: "Setup.CRM.ContactStatus.delete",
    },
    CONTACT_TYPE: {
      read: "Setup.CRM.ContactType.read",
      create: "Setup.CRM.ContactType.create",
      update: "Setup.CRM.ContactType.update",
      delete: "Setup.CRM.ContactType.delete",
    },
    CONTRACT_CATEGORY: {
      read: "Setup.CRM.ContractCategory.read",
      get: "Setup.CRM.ContractCategory.read",
      create: "Setup.CRM.ContractCategory.create",
      update: "Setup.CRM.ContractCategory.update",
      delete: "Setup.CRM.ContractCategory.delete",
    },
    CONTRACT_STATUS: {
      read: "Setup.CRM.ContractStatus.read",
      get: "Setup.CRM.ContractStatus.read",
      create: "Setup.CRM.ContractStatus.create",
      update: "Setup.CRM.ContractStatus.update",
      delete: "Setup.CRM.ContractStatus.delete",
    },
    CONTRACT_TYPE: {
      read: "Setup.CRM.ContractType.read",
      get: "Setup.CRM.ContractType.read",
      create: "Setup.CRM.ContractType.create",
      update: "Setup.CRM.ContractType.update",
      delete: "Setup.CRM.ContractType.delete",
    },
    CUSTOMER_CURRENCY: {
      read: "Setup.CRM.CustomerCurrency.read",
      create: "Setup.CRM.CustomerCurrency.create",
      update: "Setup.CRM.CustomerCurrency.update",
      delete: "Setup.CRM.CustomerCurrency.delete",
      readPlatformUser: "Setup.CRM.CustomerCurrency.readPlatformUser",
    },
    DECISION_AUTHORITY: {
      read: "Setup.CRM.DecisionAuthority.read",
      create: "Setup.CRM.DecisionAuthority.create",
      update: "Setup.CRM.DecisionAuthority.update",
      delete: "Setup.CRM.DecisionAuthority.delete",
    },
    DISQUALIFICATION_REASON: {
      read: "Setup.CRM.DisqualificationReason.read",
      create: "Setup.CRM.DisqualificationReason.create",
      update: "Setup.CRM.DisqualificationReason.update",
      delete: "Setup.CRM.DisqualificationReason.delete",
    },
    ENGAGEMENT_LEVEL: {
      read: "Setup.CRM.EngagementLevel.read",
      create: "Setup.CRM.EngagementLevel.create",
      update: "Setup.CRM.EngagementLevel.update",
      delete: "Setup.CRM.EngagementLevel.delete",
    },
    INFLUENCE_LEVEL: {
      read: "Setup.CRM.InfluenceLevel.read",
      create: "Setup.CRM.InfluenceLevel.create",
      update: "Setup.CRM.InfluenceLevel.update",
      delete: "Setup.CRM.InfluenceLevel.delete",
    },
    INQUIRY_TYPE: {
      read: "Setup.CRM.InquiryType.read",
      create: "Setup.CRM.InquiryType.create",
      update: "Setup.CRM.InquiryType.update",
      delete: "Setup.CRM.InquiryType.delete",
    },
    INTENT_LEVEL: {
      read: "Setup.CRM.IntentLevel.read",
      create: "Setup.CRM.IntentLevel.create",
      update: "Setup.CRM.IntentLevel.update",
      delete: "Setup.CRM.IntentLevel.delete",
    },
    LEAD_QUALIFICATION_MATURITY: {
      read: "Setup.CRM.LeadQualificationMaturity.read",
      create: "Setup.CRM.LeadQualificationMaturity.create",
      update: "Setup.CRM.LeadQualificationMaturity.update",
      delete: "Setup.CRM.LeadQualificationMaturity.delete",
    },
    LEAD_TYPE: {
      read: "Setup.CRM.LeadType.read",
      create: "Setup.CRM.LeadType.create",
      update: "Setup.CRM.LeadType.update",
      delete: "Setup.CRM.LeadType.delete",
    },
    NURTURE_REASON: {
      read: "Setup.CRM.NurtureReason.read",
      create: "Setup.CRM.NurtureReason.create",
      update: "Setup.CRM.NurtureReason.update",
      delete: "Setup.CRM.NurtureReason.delete",
    },
    OPPORTUNITY_TYPE: {
      read: "Setup.CRM.OpportunityType.read",
      create: "Setup.CRM.OpportunityType.create",
      update: "Setup.CRM.OpportunityType.update",
      delete: "Setup.CRM.OpportunityType.delete",
    },
    ORDER_TYPE: {
      read: "Setup.CRM.OrderType.read",
      create: "Setup.CRM.OrderType.create",
      update: "Setup.CRM.OrderType.update",
      delete: "Setup.CRM.OrderType.delete",
    },
    PAYMENT_TERM: {
      read: "Setup.CRM.PaymentTerm.read",
      create: "Setup.CRM.PaymentTerm.create",
      update: "Setup.CRM.PaymentTerm.update",
      delete: "Setup.CRM.PaymentTerm.delete",
    },
    PREFERRED_LANGUAGE: {
      read: "Setup.CRM.PreferredLanguage.read",
      create: "Setup.CRM.PreferredLanguage.create",
      update: "Setup.CRM.PreferredLanguage.update",
      delete: "Setup.CRM.PreferredLanguage.delete",
    },
    PRIORITY: {
      read: "Setup.CRM.Priority.read",
      create: "Setup.CRM.Priority.create",
      update: "Setup.CRM.Priority.update",
      delete: "Setup.CRM.Priority.delete",
    },
    PROCUREMENT_STATUS: {
      read: "Setup.CRM.ProcurementStatus.read",
      create: "Setup.CRM.ProcurementStatus.create",
      update: "Setup.CRM.ProcurementStatus.update",
      delete: "Setup.CRM.ProcurementStatus.delete",
    },
    PROSPECT_TYPE: {
      read: "Setup.CRM.ProspectType.read",
      create: "Setup.CRM.ProspectType.create",
      update: "Setup.CRM.ProspectType.update",
      delete: "Setup.CRM.ProspectType.delete",
    },
    PURCHASE_TIMELINE: {
      read: "Setup.CRM.PurchaseTimeline.read",
      create: "Setup.CRM.PurchaseTimeline.create",
      update: "Setup.CRM.PurchaseTimeline.update",
      delete: "Setup.CRM.PurchaseTimeline.delete",
    },
    QUALIFICATION_READINESS: {
      read: "Setup.CRM.QualificationReadiness.read",
      create: "Setup.CRM.QualificationReadiness.create",
      update: "Setup.CRM.QualificationReadiness.update",
      delete: "Setup.CRM.QualificationReadiness.delete",
    },
    RELATIONSHIP_STATUS: {
      read: "Setup.CRM.RelationshipStatus.read",
      create: "Setup.CRM.RelationshipStatus.create",
      update: "Setup.CRM.RelationshipStatus.update",
      delete: "Setup.CRM.RelationshipStatus.delete",
    },
    RESPONSE_STATUS: {
      read: "Setup.CRM.ResponseStatus.read",
      create: "Setup.CRM.ResponseStatus.create",
      update: "Setup.CRM.ResponseStatus.update",
      delete: "Setup.CRM.ResponseStatus.delete",
    },
    SEGMENT_TYPE: {
      read: "Setup.CRM.SegmentType.read",
      create: "Setup.CRM.SegmentType.create",
      update: "Setup.CRM.SegmentType.update",
      delete: "Setup.CRM.SegmentType.delete",
    },
    SENIORITY_LEVEL: {
      read: "Setup.CRM.SeniorityLevel.read",
      create: "Setup.CRM.SeniorityLevel.create",
      update: "Setup.CRM.SeniorityLevel.update",
      delete: "Setup.CRM.SeniorityLevel.delete",
    },
    SOURCE: {
      read: "Setup.CRM.Source.read",
      create: "Setup.CRM.Source.create",
      update: "Setup.CRM.Source.update",
      delete: "Setup.CRM.Source.delete",
    },
    TIMELINE_STATUS: {
      read: "Setup.CRM.TimelineStatus.read",
      create: "Setup.CRM.TimelineStatus.create",
      update: "Setup.CRM.TimelineStatus.update",
      delete: "Setup.CRM.TimelineStatus.delete",
    },
    WIN_LOSS_REASON: {
      read: "Setup.CRM.WinLossReason.read",
      create: "Setup.CRM.WinLossReason.create",
      update: "Setup.CRM.WinLossReason.update",
      delete: "Setup.CRM.WinLossReason.delete",
    },
  },
};

// ============================================================================
// ALL PERMISSIONS TREE
// ============================================================================
const ALL_PERMISSIONS = {
  [PLATFORM]: {
    PERMISSIONS: PLATFORM_PERMISSIONS,
    MODULES: {
      [PLATFORM_CRM]: {
        PERMISSIONS: PLATFORM_PERMISSIONS?.CRM,
        FEATURES: {
          [COMPETITOR_ROLE]: PLATFORM_PERMISSIONS?.CRM?.COMPETITOR_ROLE,
          [COMPETITOR_THREAT_LEVEL]:
            PLATFORM_PERMISSIONS?.CRM?.COMPETITOR_THREAT_LEVEL,
          [CONSENT_STATUS]: PLATFORM_PERMISSIONS?.CRM?.CONSENT_STATUS,
          [CRM_STATUS]: PLATFORM_PERMISSIONS?.CRM?.CRM_STATUS,
          [CUSTOMER_CATEGORY]: PLATFORM_PERMISSIONS?.CRM?.CUSTOMER_CATEGORY,
          [CUSTOMER_STATUS]: PLATFORM_PERMISSIONS?.CRM?.CUSTOMER_STATUS,
          [CUSTOMER_TYPE]: PLATFORM_PERMISSIONS?.CRM?.CUSTOMER_TYPE,
          [INQUIRY_DISPOSITION]: PLATFORM_PERMISSIONS?.CRM?.INQUIRY_DISPOSITION,
          [LEAD_QUALIFICATION_STATUS]:
            PLATFORM_PERMISSIONS?.CRM?.LEAD_QUALIFICATION_STATUS,
          [OPPORTUNITY_STAGE]: PLATFORM_PERMISSIONS?.CRM?.OPPORTUNITY_STAGE,
          [PERSON_TITLE]: PLATFORM_PERMISSIONS?.CRM?.PERSON_TITLE,
        },
      },
    },
  },
  [CRM]: {
    PERMISSIONS: CRM_PERMISSIONS,
    MODULES: {
      [CONFIG]: {
        PERMISSIONS: CRM_PERMISSIONS?.CONFIG,
        FEATURES: {
          [COMPETITOR]: CRM_PERMISSIONS?.CONFIG?.COMPETITOR,
          [COMPETITOR_ANALYSIS]: CRM_PERMISSIONS?.CONFIG?.COMPETITOR_ANALYSIS,
          [IDEAL_CUSTOMER_PROFILE]:
            CRM_PERMISSIONS?.CONFIG?.IDEAL_CUSTOMER_PROFILE,
          [MARKET]: CRM_PERMISSIONS?.CONFIG?.MARKET,
          [PRIVACY_CONSENT]: CRM_PERMISSIONS?.CONFIG?.PRIVACY_CONSENT,
          [PRODUCT_CONFIG]: CRM_PERMISSIONS?.CONFIG?.PRODUCT_CONFIG,
          [PRODUCTS]: CRM_PERMISSIONS?.CONFIG?.PRODUCTS,
          [SALES_REGION]: CRM_PERMISSIONS?.CONFIG?.SALES_REGION,
          [SALES_TERRITORY]: CRM_PERMISSIONS?.CONFIG?.SALES_TERRITORY,
          [SERVICES]: CRM_PERMISSIONS?.CONFIG?.SERVICES,
        },
      },
      [GENERATE]: {
        PERMISSIONS: CRM_PERMISSIONS?.GENERATE,
        FEATURES: {
          [CAMPAIGN_MANAGEMENT]: CRM_PERMISSIONS?.GENERATE?.CAMPAIGN_MANAGEMENT,
          [INQUIRY_MANAGEMENT]: CRM_PERMISSIONS?.GENERATE?.INQUIRY_MANAGEMENT,
          [LEAD_MANAGEMENT]: CRM_PERMISSIONS?.GENERATE?.LEAD_MANAGEMENT,
          [PROSPECT_MANAGEMENT]: CRM_PERMISSIONS?.GENERATE?.PROSPECT_MANAGEMENT,
          [STATUS_HISTORY]: CRM_PERMISSIONS?.GENERATE?.STATUS_HISTORY,
        },
      },
      [ORCHESTRATE]: {
        PERMISSIONS: CRM_PERMISSIONS?.ORCHESTRATE,
        FEATURES: {
          [OPPORTUNITY_MANAGEMENT]:
            CRM_PERMISSIONS?.ORCHESTRATE?.OPPORTUNITY_MANAGEMENT,
          [WON_CONTRACT]: CRM_PERMISSIONS?.ORCHESTRATE?.WON_CONTRACT,
          [WON_ORDER]: CRM_PERMISSIONS?.ORCHESTRATE?.WON_ORDER,
        },
      },
      [RELATE]: {
        PERMISSIONS: CRM_PERMISSIONS?.RELATE,
        FEATURES: {
          [CONTACT]: CRM_PERMISSIONS?.RELATE?.CONTACT,
          [CUSTOMER_ACCOUNT]: CRM_PERMISSIONS?.RELATE?.CUSTOMER_ACCOUNT,
          [CUSTOMERS]: CRM_PERMISSIONS?.RELATE?.CUSTOMERS,
        },
      },
    },
  },
  [SETUP]: {
    PERMISSIONS: SETUP_PERMISSIONS,
    MODULES: {
      [SETUP_CRM]: {
        PERMISSIONS: SETUP_PERMISSIONS?.CRM,
        FEATURES: {
          [ACCOUNT_CATEGORY]: SETUP_PERMISSIONS?.CRM?.ACCOUNT_CATEGORY,
          [ACCOUNT_TYPE]: SETUP_PERMISSIONS?.CRM?.ACCOUNT_TYPE,
          [ACTIVITY]: SETUP_PERMISSIONS?.CRM?.ACTIVITY,
          [ACTIVITY_STATUS]: SETUP_PERMISSIONS?.CRM?.ACTIVITY_STATUS,
          [ADDRESS_TYPE]: SETUP_PERMISSIONS?.CRM?.ADDRESS_TYPE,
          [ASSIGNMENT_TYPE]: SETUP_PERMISSIONS?.CRM?.ASSIGNMENT_TYPE,
          [BILLING_FREQUENCY]: SETUP_PERMISSIONS?.CRM?.BILLING_FREQUENCY,
          [BUDGET_STATUS]: SETUP_PERMISSIONS?.CRM?.BUDGET_STATUS,
          [BUSINESS_NEED_STATUS]: SETUP_PERMISSIONS?.CRM?.BUSINESS_NEED_STATUS,
          [CAMPAIGN]: SETUP_PERMISSIONS?.CRM?.CAMPAIGN,
          [CHANNEL_STATUS]: SETUP_PERMISSIONS?.CRM?.CHANNEL_STATUS,
          [CLOSURE_REASON]: SETUP_PERMISSIONS?.CRM?.CLOSURE_REASON,
          [COMPANY_SIZE]: SETUP_PERMISSIONS?.CRM?.COMPANY_SIZE,
          [COMPETITOR_STATUS]: SETUP_PERMISSIONS?.CRM?.COMPETITOR_STATUS,
          [COMPETITOR_TYPE]: SETUP_PERMISSIONS?.CRM?.COMPETITOR_TYPE,
          [CONSENT_SOURCE]: SETUP_PERMISSIONS?.CRM?.CONSENT_SOURCE,
          [CONTACT_DEPARTMENT]: SETUP_PERMISSIONS?.CRM?.CONTACT_DEPARTMENT,
          [CONTACT_METHOD]: SETUP_PERMISSIONS?.CRM?.CONTACT_METHOD,
          [CONTACT_ROLE]: SETUP_PERMISSIONS?.CRM?.CONTACT_ROLE,
          [CONTACT_STATUS]: SETUP_PERMISSIONS?.CRM?.CONTACT_STATUS,
          [CONTACT_TYPE]: SETUP_PERMISSIONS?.CRM?.CONTACT_TYPE,
          [CONTRACT_CATEGORY]: SETUP_PERMISSIONS?.CRM?.CONTRACT_CATEGORY,
          [CONTRACT_STATUS]: SETUP_PERMISSIONS?.CRM?.CONTRACT_STATUS,
          [CONTRACT_TYPE]: SETUP_PERMISSIONS?.CRM?.CONTRACT_TYPE,
          [CUSTOMER_CURRENCY]: SETUP_PERMISSIONS?.CRM?.CUSTOMER_CURRENCY,
          [DECISION_AUTHORITY]: SETUP_PERMISSIONS?.CRM?.DECISION_AUTHORITY,
          [DISQUALIFICATION_REASON]:
            SETUP_PERMISSIONS?.CRM?.DISQUALIFICATION_REASON,
          [ENGAGEMENT_LEVEL]: SETUP_PERMISSIONS?.CRM?.ENGAGEMENT_LEVEL,
          [INFLUENCE_LEVEL]: SETUP_PERMISSIONS?.CRM?.INFLUENCE_LEVEL,
          [INQUIRY_TYPE]: SETUP_PERMISSIONS?.CRM?.INQUIRY_TYPE,
          [INTENT_LEVEL]: SETUP_PERMISSIONS?.CRM?.INTENT_LEVEL,
          [LEAD_QUALIFICATION_MATURITY]:
            SETUP_PERMISSIONS?.CRM?.LEAD_QUALIFICATION_MATURITY,
          [LEAD_TYPE]: SETUP_PERMISSIONS?.CRM?.LEAD_TYPE,
          [NURTURE_REASON]: SETUP_PERMISSIONS?.CRM?.NURTURE_REASON,
          [OPPORTUNITY_TYPE]: SETUP_PERMISSIONS?.CRM?.OPPORTUNITY_TYPE,
          [ORDER_TYPE]: SETUP_PERMISSIONS?.CRM?.ORDER_TYPE,
          [PAYMENT_TERM]: SETUP_PERMISSIONS?.CRM?.PAYMENT_TERM,
          [PREFERRED_LANGUAGE]: SETUP_PERMISSIONS?.CRM?.PREFERRED_LANGUAGE,
          [PRIORITY]: SETUP_PERMISSIONS?.CRM?.PRIORITY,
          [PROCUREMENT_STATUS]: SETUP_PERMISSIONS?.CRM?.PROCUREMENT_STATUS,
          [PROSPECT_TYPE]: SETUP_PERMISSIONS?.CRM?.PROSPECT_TYPE,
          [PURCHASE_TIMELINE]: SETUP_PERMISSIONS?.CRM?.PURCHASE_TIMELINE,
          [QUALIFICATION_READINESS]:
            SETUP_PERMISSIONS?.CRM?.QUALIFICATION_READINESS,
          [RELATIONSHIP_STATUS]: SETUP_PERMISSIONS?.CRM?.RELATIONSHIP_STATUS,
          [RESPONSE_STATUS]: SETUP_PERMISSIONS?.CRM?.RESPONSE_STATUS,
          [SEGMENT_TYPE]: SETUP_PERMISSIONS?.CRM?.SEGMENT_TYPE,
          [SENIORITY_LEVEL]: SETUP_PERMISSIONS?.CRM?.SENIORITY_LEVEL,
          [SOURCE]: SETUP_PERMISSIONS?.CRM?.SOURCE,
          [TIMELINE_STATUS]: SETUP_PERMISSIONS?.CRM?.TIMELINE_STATUS,
          [WIN_LOSS_REASON]: SETUP_PERMISSIONS?.CRM?.WIN_LOSS_REASON,
        },
      },
    },
  },
};

export const getPermissionRegistry = (
  appName,
  moduleName,
  featureName,
  specific, // optional: specific permission key
) => {
  if (!appName) return null;

  const app = ALL_PERMISSIONS?.[appName];

  if (!app) return null;

  // Only Application
  if (!moduleName) return app?.PERMISSIONS;

  const module = app?.MODULES?.[moduleName];
  if (!module) return null;

  // Only module
  if (!featureName) return module?.PERMISSIONS;

  const feature = module?.FEATURES?.[featureName];

  if (!feature) return null;

  // Only feature
  if (!specific) return feature;

  // Specific permission inside feature
  return feature?.[specific] || null;
};

export {
  ACCOUNT_CATEGORY,
  ACCOUNT_TYPE,
  ACTIVITY,
  ACTIVITY_STATUS,
  ADDRESS_TYPE,
  ALL_PERMISSIONS,
  ASSIGNMENT_TYPE,
  BILLING_FREQUENCY,
  BUDGET_STATUS,
  BUSINESS_NEED_STATUS,
  CAMPAIGN, CAMPAIGN_MANAGEMENT, CHANNEL_STATUS,
  CLOSURE_REASON, COMPANY_SIZE, COMPETITOR,
  COMPETITOR_ANALYSIS, COMPETITOR_ROLE, COMPETITOR_STATUS,
  COMPETITOR_THREAT_LEVEL, COMPETITOR_TYPE, CONFIG, CONSENT_SOURCE,
  CONSENT_STATUS, CONTACT, CONTACT_DEPARTMENT,
  CONTACT_METHOD,
  CONTACT_ROLE,
  CONTACT_STATUS,
  CONTACT_TYPE,
  CONTRACT_CATEGORY,
  CONTRACT_STATUS,
  CONTRACT_TYPE,
  // CRM
  CRM, CRM_PERMISSIONS, CRM_STATUS, CUSTOMER_ACCOUNT,
  CUSTOMER_CATEGORY, CUSTOMER_CURRENCY, CUSTOMER_STATUS,
  CUSTOMER_TYPE, CUSTOMERS, DECISION_AUTHORITY,
  DISQUALIFICATION_REASON,
  ENGAGEMENT_LEVEL, GENERATE, IDEAL_CUSTOMER_PROFILE,
  INFLUENCE_LEVEL, INQUIRY_DISPOSITION, INQUIRY_MANAGEMENT, INQUIRY_TYPE,
  INTENT_LEVEL, LEAD_MANAGEMENT, LEAD_QUALIFICATION_MATURITY,
  LEAD_QUALIFICATION_STATUS, LEAD_TYPE,
  MARKET, NURTURE_REASON, OPPORTUNITY_MANAGEMENT,
  OPPORTUNITY_STAGE, OPPORTUNITY_TYPE, ORCHESTRATE,
  ORDER_TYPE,


  // Trees
  PAYMENT_TERM, PERSON_TITLE,
  PLATFORM,
  // Platform CRM
  PLATFORM_CRM, PLATFORM_PERMISSIONS,
  PREFERRED_LANGUAGE,
  PRIORITY, PRIVACY_CONSENT, PROCUREMENT_STATUS, PRODUCT_CONFIG,
  PRODUCTS, PROSPECT_MANAGEMENT, PROSPECT_TYPE,
  PURCHASE_TIMELINE,
  QUALIFICATION_READINESS, RELATE, RELATIONSHIP_STATUS,
  RESPONSE_STATUS, SALES_REGION,
  SALES_TERRITORY, SEGMENT_TYPE,
  SENIORITY_LEVEL, SERVICES,
  // Setup
  SETUP,
  SETUP_CRM, SETUP_PERMISSIONS, SOURCE,
  STATUS_HISTORY,
  TIMELINE_STATUS, WIN_LOSS_REASON, WON_CONTRACT, WON_ORDER
};

